import { Box, Typography } from "@mui/material";

export type EmptyTableStateProps = {
  message: string;
};

export function EmptyTableState({ message }: Readonly<EmptyTableStateProps>) {
  return (
    <Box p={2}>
      <Typography>{message}</Typography>
    </Box>
  );
}
